import { useEffect, useState } from 'react';

import { disableUserSelect } from 'src/styles/styles';
import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { getLocalStorage } from 'src/utils/browserStorageHandler';
import { USER_TYPE } from 'src/utils/constants/localStorageConstants';

import * as style from './ScrollToTopStyles';
import { ctaEvent } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import {
  MIXPANEL_USER_TYPE,
  MIXPANEL_ELEMENT,
  MIXPANEL_BACK_TO_TOP,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_CTA
} from '../../utils/analytics/mixpanel/mixpanelConstants';

const triggerMixPanelEvents = () => {
  clearCtaEventsProperty(mixpanelObject);
  mixpanelObject.setProperty(MIXPANEL_USER_TYPE, getLocalStorage(USER_TYPE));
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, MIXPANEL_BACK_TO_TOP);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
  ctaEvent();
};

const handleClick = () => {
  triggerMixPanelEvents();
  scrollToTop();
};

const scrollToTopOffset = 250;

export const scrollToTop = () => {
  const navigatorUserAgentRegex = /UBrowser|TV|SRAF/;
  navigator.userAgent.match(navigatorUserAgentRegex)
    ? window.scrollTo(0, 0)
    : window.scrollTo({ top: 0, behavior: 'smooth' });
};

const ScrollToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  const scrollEventHandler = () => {
    setShowButton(window.scrollY > scrollToTopOffset);
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollEventHandler);
    return () => {
      window.removeEventListener('scroll', scrollEventHandler);
    };
  }, []);

  return (
    <div
      data-testid="scroll-to-top-btn"
      css={[
        style.container,
        disableUserSelect,
        showButton && style.showContainer
      ]}
      onClick={handleClick}>
      <div css={style.ArrowUp}></div>
    </div>
  );
};
export default ScrollToTopButton;
